var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddHomepage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.875H6C5.79289 4.875 5.625 5.04289 5.625 5.25V9.75C5.625 9.95711 5.79289 10.125 6 10.125H10.5C10.7071 10.125 10.875 9.95711 10.875 9.75V5.25C10.875 5.04289 10.7071 4.875 10.5 4.875ZM6 3.75C5.17157 3.75 4.5 4.42157 4.5 5.25V9.75C4.5 10.5784 5.17157 11.25 6 11.25H10.5C11.3284 11.25 12 10.5784 12 9.75V5.25C12 4.42157 11.3284 3.75 10.5 3.75H6Z",
    fill: "#4B5058"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 4.875H14.25C14.0429 4.875 13.875 5.04289 13.875 5.25V9.75C13.875 9.95711 14.0429 10.125 14.25 10.125H18.75C18.9571 10.125 19.125 9.95711 19.125 9.75V5.25C19.125 5.04289 18.9571 4.875 18.75 4.875ZM14.25 3.75C13.4216 3.75 12.75 4.42157 12.75 5.25V9.75C12.75 10.5784 13.4216 11.25 14.25 11.25H18.75C19.5784 11.25 20.25 10.5784 20.25 9.75V5.25C20.25 4.42157 19.5784 3.75 18.75 3.75H14.25Z",
    fill: "#4B5058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6875 15.375C13.6875 15.0643 13.9393 14.8125 14.25 14.8125H19.5C19.8107 14.8125 20.0625 15.0643 20.0625 15.375C20.0625 15.6857 19.8107 15.9375 19.5 15.9375H14.25C13.9393 15.9375 13.6875 15.6857 13.6875 15.375Z",
    fill: "#4B5058"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 12.1875C17.1857 12.1875 17.4375 12.4393 17.4375 12.75L17.4375 18C17.4375 18.3107 17.1857 18.5625 16.875 18.5625C16.5643 18.5625 16.3125 18.3107 16.3125 18L16.3125 12.75C16.3125 12.4393 16.5643 12.1875 16.875 12.1875Z",
    fill: "#4B5058"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13.125H6C5.79289 13.125 5.625 13.2929 5.625 13.5V18C5.625 18.2071 5.79289 18.375 6 18.375H10.5C10.7071 18.375 10.875 18.2071 10.875 18V13.5C10.875 13.2929 10.7071 13.125 10.5 13.125ZM6 12C5.17157 12 4.5 12.6716 4.5 13.5V18C4.5 18.8284 5.17157 19.5 6 19.5H10.5C11.3284 19.5 12 18.8284 12 18V13.5C12 12.6716 11.3284 12 10.5 12H6Z",
    fill: "#4B5058"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHomepage);
export default __webpack_public_path__ + "static/media/addHomepage.aa0bbd73633c134d390ff403d257aa58.svg";
export { ForwardRef as ReactComponent };